import {
  createAsyncThunk,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import { fetchRatings } from "@/lib/api";
import type { Rating } from "@/types";

interface RatingsState {
  data: Rating[];
  loading: boolean;
  tenantId?: string;
  requestId?: string;
}

const initialState: RatingsState = { data: [], loading: false };

export const loadRatings = createAsyncThunk(
  "ratings/load",
  async (tenantId: string) => {
    const ratings = await fetchRatings(tenantId);
    return ratings ?? [];
  },
);

const ratingsSlice = createSlice({
  name: "ratings",
  initialState,
  reducers: {
    setRatings(state, action: PayloadAction<Rating[] | null>) {
      state.data = action.payload ?? [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadRatings.pending, (state, action) => {
        if (state.tenantId !== action.meta.arg) state.data = [];
        state.tenantId = action.meta.arg;
        state.requestId = action.meta.requestId;
        state.loading = true;
      })
      .addCase(loadRatings.fulfilled, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.loading = false;
        state.data = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(loadRatings.rejected, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.loading = false;
      });
  },
});

export const { setRatings } = ratingsSlice.actions;
export default ratingsSlice.reducer;
